/* eslint-disable no-restricted-imports */
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { LIDO_STETH_TOKEN } from '../constants';
export var Deposit = createPlugin({
    protocol: 'LIDO',
    type: 'ACTION',
    method: 'submit',
    supportedContracts: LIDO_STETH_TOKEN,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            value: new FctValue({}),
            methodParams: {
                referral: new FctAddress({ required: false }),
            },
        },
        output: {},
    }); },
    initParams: {
        methodParams: {
            referral: ethers.constants.AddressZero,
        },
    },
});
